/**
 * Edge-safe consent primitives. No `js-cookie` / `next/headers` imports so
 * middleware (Edge runtime), server components, and client components can
 * all use these.
 */

export type ConsentValue = "accepted" | "declined";

export const CONSENT_COOKIE_NAME = "cookie_consent";
/** Bump this when the consent policy changes to re-prompt users. */
export const CONSENT_VERSION = 3;

/** Parse a versioned consent cookie value like "accepted:1" */
export function parseConsent(
  raw: string | undefined,
): ConsentValue | undefined {
  if (!raw) return undefined;
  const [value, version] = raw.split(":");
  if (Number(version) !== CONSENT_VERSION) return undefined;
  if (value === "accepted" || value === "declined") return value;
  return undefined;
}
